export const AlertCategory: { [key: string]: string } = {
  PREFACTURATION: 'Publication préfacturation',
  FACTURATION: 'Facturation',
  GENERATION: 'Génération facturation',
  CONTRACTUAL: 'Informations contractuelles',
};

export const getAlertCategory = (category: string): string => AlertCategory[category] || 'Non défini';
